interface IBreakpointZoomsMapEntry {
    crsCode: string;
    xxs: number;
    xs: number;
    sm: number;
    md: number;
    lg: number; 
    xl: number;
    default: number;
}

const breakpointMinTileDownloadZoomMap: IBreakpointZoomsMapEntry[] = [
    { crsCode: "EPSG:27700", xxs: 2, xs: 2, sm: 2, md: 3, lg: 3, xl: 3, default: 3 },
    { crsCode: "EPSG:3857", xxs: 11, xs: 11, sm: 11, md: 10, lg: 9, xl: 9, default: 11 }
];

export const getMinZoomForTileDownload = function(crsCode: string, styleBreakpoint: string): number {

    const entry = breakpointMinTileDownloadZoomMap.find(me => me.crsCode === crsCode);
    if (!entry)
        throw Error(`Zoom mapping not found for CRS code '${crsCode}'.`);

    const zoom = (entry as any)[styleBreakpoint.toLowerCase()] ?? entry.default;

    return zoom;
};
